import config from 'constants/config'

export function isProduction(): boolean {
  return config.APP_ENV === 'production'
}
